/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-16T15:24:16.802
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import BasicLayout from '@/layouts/basic-layout';

const meta = {
auth: true
};

const pre = 'rentmanage-RentTakeLookRecord-'

export default 
{
path: '/rentmanage/renttakelookrecord',
name: 'rentmanage-RentTakeLookRecord',
redirect: {
name: '${pre}-index'
}
,

meta:{
...meta,
},

component: BasicLayout ,
children:
[
{
path: 'index',
name: '${pre}RentTakeLookRecord-index',

meta:{
...meta,
title: '预约带看'
},

component: () => import('@/pages/rentmanage/renttakelookrecord/index') ,
},
{
	path: 'indexStatistics',
	name: '${pre}RentTakeLookRecord-indexStatistics',

	meta:{
	...meta,
	title: '带看统计'
	},

	component: () => import('@/pages/rentmanage/renttakelookrecord/indexStatistics') ,
}, 
{
path: 'detail-edit/:id',
name: '${pre}RentTakeLookRecord-detail-edit',
auth: [
'hidden'
],

meta:{
...meta,
title: '预约带看编辑'
},

component: () => import('@/pages/rentmanage/renttakelookrecord/detail-edit') ,
},
{
path: 'detail-edit',
name: '${pre}RentTakeLookRecorddetail-create',
auth: [
'hidden'
],

meta:{
...meta,
title: '预约带看新增'
},

component: () => import('@/pages/rentmanage/renttakelookrecord/detail-edit') ,
},
{
path: 'detail-view/:id',
name: '${pre}RentTakeLookRecordView',
auth: [
'hidden'
],

meta:{
...meta,
title: '预约带看详情查看'
},

component: () => import('@/pages/rentmanage/renttakelookrecord/detail-view') ,
},
]
};
